import React, { lazy } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import GraphContainer from '../GraphContainer'

import { socialReturnOnInvestmentReportSelector } from '../../../../../modules/selectors/socialReturnOnInvestment'

const UnitedKingdomMap = lazy(() => import('./maps/UnitedKingdomMap'))
const AustraliaMap = lazy(() => import('./maps/AustraliaMap'))

const ImpactByRegion = () => {
  const { t } = useTranslation()

  const { countryOfOperation } = useSelector(socialReturnOnInvestmentReportSelector)

  return (
    <GraphContainer title={t('Impact by Region')}>
      {countryOfOperation === 'AUS' && <AustraliaMap />}
      {countryOfOperation === 'GBR' && <UnitedKingdomMap />}
    </GraphContainer>
  )
}

export default ImpactByRegion
